import Service from '../Service'

class IntegrationService extends Service {
  constructor() {
    super('')
    this.resource = 'integrations'
  }

  createRequestUrl(payload) {
    let requestUrl = `${this.resource}?`

    if (payload.name)
      requestUrl += this.hasParameter(requestUrl)
        ? `&NOME_EMPRESA=${payload.name}`
        : `NOME_EMPRESA=${payload.name}`
    if (payload.todos)
      requestUrl += this.hasParameter(requestUrl)
        ? `&TODOS=${payload.todos}`
        : `TODOS=${payload.todos}`
    return requestUrl
  }

  convertToFirebird(payload) {
    let obj = {
      NOME_EMPRESA: payload.integrationName || payload.NOME_EMPRESA,
      USERNAME: payload.userID || payload.USERNAME,
      PASSWORD: payload.accessKey || payload.PASSWORD,
      BASE_URL: payload.serviceURL || payload.BASE_URL,
      AUTHCODEPARTNER: payload.authCodePartner || payload.AUTHCODEPARTNER,
      IDMERCHANT: payload.idMerchant || payload.IDMERCHANT,
      DE_PARA: payload.dePara || payload.DE_PARA,
      ATIVO: payload.ATIVO ?? 'N',
      usuariosMensagem: payload.usuariosMensagem,
      ITEM_TAXAENTREGA:
        payload.itemTaxaEntrega || payload.ITEM_TAXAENTREGA || null,
      ITEM_GENERICO: payload.itemGenerico || payload.ITEM_GENERICO || null,
      COLUNAS_EXPORTACAO:
        payload.colunasExportacao || payload.COLUNAS_EXPORTACAO,
      FILIAL: payload.filial || payload.FILIAL,
      CONVERTEPESOGRAMAS:
        payload.convertePesoGramas || payload.CONVERTEPESOGRAMAS,
      CONVERTEMEDIDACM: payload.converteMedidaCm || payload.CONVERTEMEDIDACM,
      CONFIRMACAOAUTOMATICA:
        payload.confirmacaoAutomatica || payload.CONFIRMACAOAUTOMATICA,
      TIPOPRECO: payload.tipoPreco || payload.TIPOPRECO,
    }
    return obj
  }

  async saveIntegration(payload) {
    let integrationObject = this.convertToFirebird(payload)
    return await this.insert(integrationObject)
  }

  async updateIntegration(payload) {
    let integrationObject = this.convertToFirebird(payload)
    return await this.update(integrationObject, integrationObject.NOME_EMPRESA)
  }

  async getIntegration(payload) {
    let requestUrl = this.createRequestUrl(payload)
    return await this.getAPI(requestUrl)
  }

  async getIntegrationData(payload) {
    let requestUrl = `${this.resource}/${payload}`
    return await this.getAPI(requestUrl)
  }

  async deleteIntegration(payload) {
    return await this.delete(payload)
  }
}

export default new IntegrationService()
